import * as Yup from "yup";

export const formSchema = Yup.object().shape({
  file: Yup.mixed().required("File is required"),
});
